import {BaseEntity} from '../../app-common/data/BaseEntity';

export class Category extends BaseEntity<number> {
  name: string;
  shortDescription: string;
  longDescription: string;
}

